import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { PromptBox } from '../PromptBox';
import { TestimonialsSection } from '../TestimonialsSection';
import { TextBanner } from '../TextBanner';
import { FAQs } from '../FAQs';
import { BottomDrawer } from '../BottomDrawer';
import { SellersSection } from '../SellersSection';
import { LogosSection } from '../LogosSection';
import { StepsSection } from '../StepsSection';

export const LandingPageLayout = () => (
    <Stack direction="column" justifyContent="center" alignItems="stretch" gap="0">
        <PromptBox />
        <LogosSection />
        <SellersSection />
        <StepsSection />
        <TestimonialsSection />
        <TextBanner />
        <FAQs />
        <BottomDrawer />
    </Stack>
);
